module.exports = __webpack_public_path__ + "static/img/yysc@2x.aaeeac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yysc@2x.png
// module id = 9QWD
// module chunks = 2